import { render, staticRenderFns } from "./mo-alert.html?vue&type=template&id=75d01a96&external"
import script from "./mo-alert.ts?vue&type=script&lang=ts&external"
export * from "./mo-alert.ts?vue&type=script&lang=ts&external"
import style0 from "./mo-alert.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/agent/_work/3/s/Be.Vlaanderen.Mo.Vue/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75d01a96')) {
      api.createRecord('75d01a96', component.options)
    } else {
      api.reload('75d01a96', component.options)
    }
    module.hot.accept("./mo-alert.html?vue&type=template&id=75d01a96&external", function () {
      api.rerender('75d01a96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/mo-alert/mo-alert.vue"
export default component.exports